import { Price } from "../../../redux/user/userSlice";
import axios from "../../privateApi";

export interface FetchPricesResponse {
  prices: Price[];
  currency: string;
  countryCode: string;
}

export const fetchPrices = async (): Promise<FetchPricesResponse> => {
  return axios.get("/payments/prices").then((response) => {
    return response.data;
  });
};
